module.exports = __webpack_public_path__ + "img/e2.bc3a3083.png";